export interface ICustomer {
  id?: string;
  name: string;
}

export default class Customer {
  private id?: string;
  private name: string;

  constructor(dto: ICustomer) {
    Object.assign(this, dto);
  }

  get getId(): string {
    return this.id;
  }

  set setId(id: string) {
    this.id = id;
  }

  get getName(): string {
    return this.name;
  }

  set setName(name: string) {
    this.name = name;
  }
}
